module.exports = __webpack_public_path__ + "img/icons-text-slider.95be1bc6.png";